// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fa0d0fa9","79":"aa077802","188":"b6d69f9d","334":"881a84a7","452":"0f22a28c","605":"3015aa5d","787":"96af3d80"}[chunkId] + ".chunk.js";
};